// extracted by mini-css-extract-plugin
module.exports = {"root":"Loader_root__3yaJS"};